import React from 'react';
import SearchInput from '../shared/SearchInput';

const STATUS_OPTIONS = [
  { value: '', label: 'Todas las activas' },
  { value: 'pendiente', label: 'Pendiente' },
  { value: 'en_progreso', label: 'En progreso' },
  { value: 'bloqueada', label: 'Bloqueada' },
  { value: 'hecha', label: 'Hecha' },
  { value: 'cancelada', label: 'Cancelada' },
];

const PRIORITY_OPTIONS = [
  { value: '', label: 'Todas' },
  { value: 'critica', label: 'Crítica' },
  { value: 'alta', label: 'Alta' },
  { value: 'media', label: 'Media' },
  { value: 'baja', label: 'Baja' },
];

function TasksFilters({ filters, onChange }) {
  const hasFilters = filters.status || filters.priority || filters.search;

  function set(key, val) {
    onChange({ ...filters, [key]: val, page: 1 });
  }

  return (
    <div className="filters-bar">
      <select className="filter-select" value={filters.status} onChange={e => set('status', e.target.value)}>
        {STATUS_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <select className="filter-select" value={filters.priority} onChange={e => set('priority', e.target.value)}>
        {PRIORITY_OPTIONS.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
      <SearchInput value={filters.search} onChange={v => set('search', v)} placeholder="Buscar tareas..." />
      {hasFilters && (
        <button className="btn-secondary" onClick={() => onChange({ status: '', priority: '', search: '', page: 1, limit: 20 })}>
          ✕ Limpiar
        </button>
      )}
    </div>
  );
}

export default TasksFilters;
